var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex fd-column ITEM p-b-2"},[_c('img',{staticClass:"IMAGE m-b-3",attrs:{"src":_vm.step.image,"alt":_vm.step.altText}}),_c('div',{staticClass:"h5 text-bold p-x-1:mo m-b-1"},[_vm._v(_vm._s(_vm.step.title))]),_c('p',{staticClass:"p-x-1:mo"},[_vm._v(_vm._s(_vm.step.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }